export default "__VITE_PUBLIC_ASSET__813afe3f__"